import { useAuthStore } from '@/modules/auth/store/auth';

export default defineNuxtRouteMiddleware(async (to) => {
  const auth = useAuth();
  const accessToken = useCookie('accessToken');
  const { user } = storeToRefs(useAuthStore());
  const { showSnackbar } = useSnackbar();

  const publicPages = [
    '/verify',
    '/login',
    '/register',
    '/forgot-password',
    '/reset-password',
    '/terms-and-conditions',
    '/privacy-policy',
  ];

  const isPublic = publicPages.includes(to.path);
  if (isPublic) return;

  async function invalidateUser() {
    accessToken.value = null;
    user.value = null;
    // showSnackbar({ text: 'Account is blocked or deleted', state: false });
    return navigateTo('/login');
  }

  try {
    const session = await auth.getSession();
    if (!session) return invalidateUser();
    if (session.data.onboarded_at === null && to.path !== '/onboarding') return navigateTo('/onboarding');
  } catch {
    return invalidateUser();
  }
});
